!function ($, global) {
    'use strict';

    var isMobile = /mobi/i.test(global.navigator.userAgent);

    var $window = $(global);
    var $body = $(global.document.body);
    var $navbar = $('.navbar');
    var $panel = $('#navbar-side-panel');
    var $mobilePanel = $('#mobile-side-panel');
    var $mobileContainer = $mobilePanel.children('.modal-panel');


    var ACTIVE_BODY_CLASS = 'modal-panel-open';

    $panel
        .on('show.bs.modal', function () {
            $body.addClass(ACTIVE_BODY_CLASS);
        })
        .on('hide.bs.modal', function () {
            $body.removeClass(ACTIVE_BODY_CLASS);
        });

    // Cursor

    if (!isMobile) {
        var $close = $panel.find('.btn-toggler-close');
        var $cursorClose = $panel.find('.modal-cursor-btn-toggler');
        var closeActive;

        var restoreClose = function () {
            $close.removeClass('invisible');
            $cursorClose.hide();
        };

        $panel
            .addClass('modal-hide-cursor')
            .on('mousemove', function (event) {
                var $target = $(event.target);
                var isClosable = $target.data('modalPanelClosableTarget');

                // Store is closable property
                if(isClosable === undefined) {
                    $target.data('modalPanelClosableTarget', isClosable = !$target.parents().add($target).filter('.no-close,a,button').not($cursorClose).length)
                }

                if (closeActive && isClosable) {
                    $close.addClass('invisible');
                    $cursorClose.show().css('transform', 'translate(' + event.clientX + 'px,' + event.clientY + 'px)');
                } else {
                    restoreClose();
                }
            })
            .on('shown.bs.modal', function () {
                closeActive = true;
            })
            .on('hide.bs.modal', function () {
                closeActive = false;
                restoreClose();
            });
    }

    //

    function updateMobilePanel() {
        $mobileContainer.css('padding-top', $navbar.outerHeight());
    }

    $window.on('resize', updateMobilePanel);
    updateMobilePanel();
    $(updateMobilePanel);

}(jQuery, window);